<template>
  <div class="app-container">
    <iframe
      id="iframeDom" 
      ref="iframeDom"
      :src="srcUrl"
      frameborder="0"
      allowfullscreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    />
  </div>
</template>

<script>
import Service from '../../../../../env/index'
import {getCustInfoList} from '../../api'

export default {
  name: 'IframeView',
  components: {},
  data() {
    return {
      srcUrl: '',
      customerShortName:''
    }
  },
  async mounted() {
    let customerCode = ''
    const {user} = this.$store.state || {}
    if (user.customers?.length) {
      customerCode = user.customers[0].customerCode
    } else {
      customerCode = user.customerCode
    }
    const token = this.$store.state?.user?.token || '';
    const {waybillCode,startName,endName} = this.$route.query;
    await this.getCustInfoList(customerCode)
    this.srcUrl = `${Service.IFRAME_ORIGIN}/#/consignorView/transitMonitorAnalysis?appToken=${token}&customerCode=${customerCode}&waybill_code=${waybillCode}&customer_short_name=${this.customerShortName}&startName=${startName}&endName=${endName}&source=oms_order_details`
  },
  methods: { 
    async getCustInfoList(customerCode){
      const res =await getCustInfoList({
        filter: {
          customer_code: customerCode,
        },
        paging: false,
      })
      if(res.records&&res.records.length){
        this.customerShortName = res.records[0]?.customer_short_name||undefined;
      }else{
        this.customerShortName = undefined;
      }
    }
  }
}
</script>
<style scoped>
#iframeDom {
  width: 100%;
  height: 100%;
  display: block;
}
.app-container {
  padding: 0 24px;
  height: calc(100vh - 80px);
}
</style>

